const initFaqAccordion = () => {
    const accordions = document.querySelectorAll('.js-faq-accordion');
    
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        accordion.addEventListener('click', (e) => {
            const trigger = e.target.closest('.js-faq-trigger');
            if (!trigger) return;

            const item = trigger.closest('.js-faq-item');
            if (!item) return;

            const isActive = item.classList.contains('is-active');
            const activeItem = accordion.querySelector('.js-faq-item.is-active');
            
            if (activeItem && activeItem !== item) {
                activeItem.classList.remove('is-active');
                activeItem.querySelector('.js-faq-trigger').setAttribute('aria-expanded', 'false');
            }

            if (!isActive) {
                item.classList.add('is-active');
                trigger.setAttribute('aria-expanded', 'true');
            } else {
                item.classList.remove('is-active');
                trigger.setAttribute('aria-expanded', 'false');
            }
        });
    });
};

window.addEventListener('load', () => {
    initFaqAccordion();
});